export const REVIEW_STATUS = {
  RASCUNHO: "RASCUNHO",
  ENVIADO: "ENVIADO",
  EM_ANALISE: "EM_ANALISE",
  GESTAO_NACIONAL: "GESTAO_NACIONAL",
  COMPLEMENTAR: "COMPLEMENTAR",
  DEFERIDO: "DEFERIDO",
  INDEFERIDO: "INDEFERIDO",
  CANCELADO: "CANCELADO",
};

export const REVIEW_STATUSES = [
  {
    value: REVIEW_STATUS.RASCUNHO,
    text: "Rascunho",
    color: "grey",
  },
  {
    value: REVIEW_STATUS.ENVIADO,
    text: "Enviado",
    color: "primary",
  },
  {
    value: REVIEW_STATUS.EM_ANALISE,
    text: "Em análise",
    color: "warning",
  },
  {
    value: REVIEW_STATUS.GESTAO_NACIONAL,
    text: "Gestão Nacional",
    color: "deep-purple",
  },
  {
    value: REVIEW_STATUS.COMPLEMENTAR,
    text: "Complementar",
    color: "orange",
  },
  {
    value: REVIEW_STATUS.DEFERIDO,
    text: "Deferido",
    color: "success",
  },
  {
    value: REVIEW_STATUS.INDEFERIDO,
    text: "Indeferido",
    color: "error",
  },
  {
    value: REVIEW_STATUS.CANCELADO,
    text: "Cancelado",
    color: "grey darken-1",
  },
];

export const DEFAULT_STATUS_ORDER = REVIEW_STATUSES.map((status) => status.value);

export const findStatusMeta = (status) =>
  REVIEW_STATUSES.find((item) => item.value === status) || {
    value: status,
    text: status,
    color: "grey",
  };

const normalizeStatusValue = (status) => {
  if (status === null || status === undefined) {
    return "";
  }

  return String(status).trim().toUpperCase();
};

export const normalizeReviewStatus = (status) => {
  const normalized = normalizeStatusValue(status);

  if (!normalized) {
    return normalized;
  }

  if (normalized === REVIEW_STATUS.GESTAO_NACIONAL) {
    return REVIEW_STATUS.EM_ANALISE;
  }

  if (normalized === REVIEW_STATUS.ENVIADO) {
    return REVIEW_STATUS.EM_ANALISE;
  }

  return normalized;
};

export const isReviewStatusGestaoNacional = (status) =>
  normalizeStatusValue(status) === REVIEW_STATUS.GESTAO_NACIONAL;

